import { useEffect, useMemo, useState } from "react";
import {
  buildLabelsFromValues,
  mergeLabelsFromValues,
  toLabelColorMap,
  toLabelOptions,
} from "../utils/labels";

export const useLabels = (values = []) => {
  const [labels, setLabels] = useState(() => buildLabelsFromValues(values));

  useEffect(() => {
    if (!values?.length) return;
    setLabels((prev) => mergeLabelsFromValues(prev, values));
  }, [values]);

  const labelOptions = useMemo(() => toLabelOptions(labels), [labels]);
  const labelColorMap = useMemo(() => toLabelColorMap(labels), [labels]);

  return { labels, setLabels, labelOptions, labelColorMap };
};
